var React = require('react');

function ArrowAltFromLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 424V88a23.94 23.94 0 0 1 24-24h16a23.94 23.94 0 0 1 24 24v336a23.94 23.94 0 0 1-24 24H24a23.94 23.94 0 0 1-24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96 296v-80a23.94 23.94 0 0 1 24-24h136v-87.8c0-17.8 21.51-26.7 34.11-14.1l152.26 152.2a19.36 19.36 0 0 1 0 27.3L290.14 421.8c-12.6 12.6-34.11 3.7-34.11-14.1V320H120a23.94 23.94 0 0 1-24-24z","className":"fa-primary","key":2})]);
}

ArrowAltFromLeft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowAltFromLeft;

ArrowAltFromLeft.default = ArrowAltFromLeft;
